var { requireNativeComponent, NativeModules, Platform } = require('react-native');

if( Platform.OS === "ios" )
{
  module.exports = requireNativeComponent('RNCardIOView', null);
}
else
{
  module.exports = NativeModules.RNCardIO;
}



// WEBPACK FOOTER //
// ./src/CardIO.js